/** @format */

export const FacebookLarge = ({color}) => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_64_99)">
                <path
                    d="M29.3327 16C29.3327 8.63622 23.3631 2.66669 15.9993 2.66669C8.63555 2.66669 2.66602 8.63622 2.66602 16C2.66602 22.655 7.5418 28.1711 13.916 29.1714V19.8542H10.5306V16H13.916V13.0625C13.916 9.72085 15.9066 7.87502 18.9522 7.87502C20.4105 7.87502 21.9368 8.13544 21.9368 8.13544V11.4167H20.2556C18.5993 11.4167 18.0827 12.4446 18.0827 13.5V16H21.7806L21.1895 19.8542H18.0827V29.1714C24.4569 28.1711 29.3327 22.655 29.3327 16Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_64_99">
                    <rect width="32" height="32" fill={color} />
                </clipPath>
            </defs>
        </svg>
    );
};
